var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 83,
    viewBox: "0 0 92 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1322_2783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.3837 10.375C79.2927 10.375 80.842 11.9243 80.842 13.8333V69.1667C80.842 71.0757 79.2927 72.625 77.3837 72.625H22.0503C20.1413 72.625 18.592 71.0757 18.592 69.1667V13.8333C18.592 11.9243 20.1413 10.375 22.0503 10.375H77.3837ZM46.9123 45.5047L25.5087 49.2812V65.7083H50.4709L46.9088 45.5047H46.9123ZM73.9253 17.2917H48.9596L57.4948 65.7083H73.9253V17.2917ZM41.9358 17.2917H25.5087V42.2539L45.7123 38.6918L41.9358 17.2917Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1322_2783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2479 44.8938L16.3626 48.4024L15.9697 48.4718V48.8708V64.4944V64.9699H16.4452H40.1865H40.7533L40.6549 64.4118L37.267 45.1964L36.8429 45.2712L36.802 44.8034H36.7987H36.2319L36.2479 44.8938ZM62.9693 18.4458V17.9703H62.4938H38.7492H38.1824L38.2808 18.5284L46.3985 64.5769L46.4678 64.9699H46.8669H62.4938H62.9693V64.4944V18.4458ZM32.5371 18.3632L32.4678 17.9703H32.0688H16.4452H15.9697V18.4458V42.1871V42.7539L16.5278 42.6555L35.7432 39.2676L36.2116 39.185L36.1289 38.7166L32.5371 18.3632ZM65.783 12.343C67.336 12.343 68.5966 13.6036 68.5966 15.1566V67.7836C68.5966 69.3366 67.336 70.5972 65.783 70.5972H13.156C11.603 70.5972 10.3424 69.3366 10.3424 67.7836V15.1566C10.3424 13.6036 11.603 12.343 13.156 12.343H65.783Z",
    stroke: "white",
    strokeWidth: 0.951089
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1322_2783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 83,
    fill: "white",
    transform: "translate(8.21777)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1322_2783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.9404,
    height: 78.9404,
    fill: "white",
    transform: "translate(0 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService3);
export default __webpack_public_path__ + "static/media/Service3.4eb39404fb08aa82abe4a1d074e64b90.svg";
export { ForwardRef as ReactComponent };